exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nbody {\n    padding-right: 0px;\n    background: none;\n}\n", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/layouts/Home.vue"],"names":[],"mappings":";AACA;IACI,mBAAmB;IACnB,iBAAiB;CACpB","file":"Home.vue","sourcesContent":["\nbody {\n    padding-right: 0px;\n    background: none;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-203d1c30","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/layouts/Home.vue
// module id = Q4wa
// module chunks = 56